import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type RangeFilter } from '../types/filters';

const DEFAULT_MIN_FUNDING = 0;
const DEFAULT_MAX_FUNDING = Number.MAX_SAFE_INTEGER;

export const lastFundingAmountDefinition: FilterDefinition<RangeFilter> = {
  id: FilterId.LAST_FUNDING_AMOUNT,
  name: 'Last Funding Amount',
  type: FilterType.RANGE,
  min: undefined,
  max: undefined,
  isActive: false,
  isVisible: true,
};

export const lastFundingAmountHandler: FilterHandler<RangeFilter> = {
  isActive(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min !== undefined ||
      currentFilterState.max !== undefined
    );
  },
  isDefault(currentFilterState: RangeFilter) {
    return (
      currentFilterState.min === undefined &&
      currentFilterState.max === undefined
    );
  },
  getEffectiveFilter(currentFilterState: RangeFilter) {
    return {
      ...currentFilterState,
      min: currentFilterState.min ?? DEFAULT_MIN_FUNDING,
      max: currentFilterState.max ?? DEFAULT_MAX_FUNDING,
    };
  },
};
